export enum JackpotCreateSteps {
  MainPage = 0,
}